import React from 'react';
import { Outlet } from 'react-router-dom';

const OnlineGiftCard = () => {
    return (
        <React.Fragment>
            <Outlet />
        </React.Fragment>
    );
};

export default OnlineGiftCard;